export default "__VITE_ASSET__18c6ed64__"